import base from './base';
import helsinki from './helsinki';

export const DEFAULT_THEME = 'base';

export const themes = {
  base,
  helsinki,
};